/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OperatingCostInvoiceAiJobResultDto } from '../models/OperatingCostInvoiceAiJobResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiJobService {
  /**
   * @param ticketId
   * @returns OperatingCostInvoiceAiJobResultDto Operating cost invoice AI job results grouped by document ID.
   * @throws ApiError
   */
  public static aiJobControllerGetOperatingCostInvoiceResultsByTicketV1(
    ticketId: string,
  ): CancelablePromise<Record<string, Array<OperatingCostInvoiceAiJobResultDto>>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/ai-job/operating-cost-invoice/results/tickets/{ticketId}',
      path: {
        ticketId: ticketId,
      },
    });
  }
  /**
   * @param ticketId
   * @param documentId
   * @returns OperatingCostInvoiceAiJobResultDto
   * @throws ApiError
   */
  public static aiJobControllerGetOperatingCostInvoiceResultsV1(
    ticketId: string,
    documentId: string,
  ): CancelablePromise<Array<OperatingCostInvoiceAiJobResultDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/ai-job/operating-cost-invoice/results/tickets/{ticketId}/documents/{documentId}',
      path: {
        ticketId: ticketId,
        documentId: documentId,
      },
    });
  }
}
